import { Box, Grid2 as Grid } from "@mui/material";

import { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";

import CreateNocBanner from "./CreateNocBanner";
import NocSelectedPackage from "./NocSelectedPackage";
import CustomNocPaymentModal from "./CustomNocPaymentModal";
import AddPaymentCardModal from "../../../modals/AddPaymentCardModal";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { currentProcessingNocFileBase } from "../../../../data/userPackage/prepareNoc";
import { clearCustomCreateNoc } from "../../../../store/actions/userPackagesActions";
import { setModalsState } from "../../../../store/actions/uiActions/myPermitsActions";

const IntroModal = ({
  packagePanelOpen,
  currentProcessingFile,
  setCurrentProcessingFile,
  onBanner,
  setOnBanner,
  loadInitNoc,
  discardNocLoading,
  handleDiscardInitNoc,
  initNocLoading,
  handleLoadInitNoc,
  checkInitLoading,
  cards,
  stripe,
  elements,
  CardElement,
}) => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession]?.user);
  const { addPaymentModalOpen, paymentModalOpen } = useSelector(
    (state) => state.myPermitsComponent.permits.modalStates
  );

  // const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [paymentLoading, setPaymentLoading] = useState(false);
  // const [addPaymentModalOpen, setAddPaymentModalOpen] = useState(false);
  const [actionText, setActionText] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [paymentErrorText, setPaymentErrorText] = useState("");
  const [displaySuccess, setDisplaySuccess] = useState(false);

  const dispatch = useDispatch();

  const handleStartProcessing = async () => {
    try {
      setPaymentLoading(true);

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/stripe/custom-documents/noc/process-payment`,
        {
          paymentCard: cards[activeStep]?.id,
          packageID: currentProcessingFile?.packageID,
          package: currentProcessingFile,
          acknowledged: true,
          currentSession: currentSession,
        },
        { withCredentials: true }
      );

      const stripe = await loadStripe(process.env.REACT_APP_STRIPE);
      const result = await stripe.confirmCardPayment(resp.data.data);

      if (result.error) {
        setPaymentErrorText(result.error.message);
      } else {
        if (
          result.paymentIntent.status === "succeeded" &&
          resp.data.valid === true
        ) {
          // If not admin, process the final step with paymentIntent
          const paymentIntent = result.paymentIntent;
          const finalResp = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/nocApi/stripe/custom-documents/noc/finalize-payment`,
            {
              paymentIntent,
              document: currentProcessingFile,
              currentSession: currentSession,
            },
            { withCredentials: true }
          );

          if (finalResp.data.success) {
            setCurrentProcessingFile(currentProcessingNocFileBase);
            dispatch(clearCustomCreateNoc());
            setDisplaySuccess(finalResp?.data?.customID);
            setOnBanner(true);
            setPaymentLoading(false);
            setPaymentErrorText("");
          }
        }
      }
    } catch (error) {
      console.error("Error processing payment:", error);
    } finally {
      setPaymentLoading(false);
    }
  };

  useEffect(() => {
    if (addPaymentModalOpen && cards.length > 0) {
      dispatch(setModalsState({ addPaymentModalOpen: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cards, addPaymentModalOpen]);

  useEffect(() => {
    const priceTiers = currentUser?.service_tiers?.custom_document?.noc;
    if (actionText === "Notarize & Record") {
      setTotalAmount(parseFloat(priceTiers?.notary_record));
    } else if (actionText === "Notarize Only") {
      setTotalAmount(parseFloat(priceTiers?.notary));
    } else if (actionText === "Record Only") {
      setTotalAmount(parseFloat(priceTiers?.record));
    }
  }, [actionText, currentUser?.service_tiers?.custom_document?.noc]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "80%",
        maxWidth: "950px",
        height: "90vh",
        bgcolor: "white",
        boxShadow: !packagePanelOpen
          ? undefined
          : "4px 4px 8px 5px rgba(0, 0, 0, 0.3)",
        borderRadius: 2,
        overflow: "auto",
        mx: "auto",
        my: 4,
      }}
    >
      <Grid container spacing={1} sx={{ p: 2, height: "100%" }}>
        {/* Right Panel (Scrollable) */}
        <Grid
          size={{ xs: 12 }}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {onBanner ? (
            <CreateNocBanner
              setOnBanner={setOnBanner}
              currentProcessingFile={currentProcessingFile}
              setCurrentProcessingFile={setCurrentProcessingFile}
              // setAddingNewDocument={setAddingNewDocument}
              loadInitNoc={loadInitNoc}
              discardNocLoading={discardNocLoading}
              handleDiscardInitNoc={handleDiscardInitNoc}
              initNocLoading={initNocLoading}
              handleLoadInitNoc={handleLoadInitNoc}
              checkInitLoading={checkInitLoading}
            />
          ) : currentProcessingFile?.document?.tempFields?.currentDocument
              ?.base64File ? (
            <NocSelectedPackage
              currentProcessingFile={currentProcessingFile}
              setCurrentProcessingFile={setCurrentProcessingFile}
              handleDiscardInitNoc={handleDiscardInitNoc}
              setOnBanner={setOnBanner}
              // setPaymentModalOpen={setPaymentModalOpen}
              // setAddPaymentModalOpen={setAddPaymentModalOpen}
              cards={cards}
              actionText={actionText}
              setActionText={setActionText}
            />
          ) : (
            <></>
          )}
        </Grid>
      </Grid>

      <AddPaymentCardModal
        stripe={stripe}
        elements={elements}
        CardElement={CardElement}
      />

      <CustomNocPaymentModal
        open={paymentModalOpen}
        onClose={() => {
          if (paymentLoading) {
            return;
          } else {
            dispatch(setModalsState({ paymentModalOpen: false }));
          }
        }}
        displaySuccess={displaySuccess}
        onConfirm={handleStartProcessing}
        totalAmount={totalAmount}
        paymentCards={cards}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        actionText={actionText}
        paymentLoading={paymentLoading}
        paymentErrorText={paymentErrorText}
      />
    </Box>
  );
};

export default IntroModal;
